import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import {HealthReportDashboardTypeEnum} from '@/enum/health-report-dashboard-type-enum';
import baby_sitting_skinType_1 from '@/public/images/baby_sitting_skin_1.svg';
import baby_sitting_skinType_2 from '@/public/images/baby_sitting_skin_2.svg';
import baby_sitting_skinType_3 from '@/public/images/baby_sitting_skin_3.svg';
import baby_sitting_skinType_4 from '@/public/images/baby_sitting_skin_4.svg';
import baby_sitting_skinType_5 from '@/public/images/baby_sitting_skin_5.svg';
import baby_sitting_skinType_6 from '@/public/images/baby_sitting_skin_6.svg';

const HealthReportNoRecording = ({patient, activeDashboard}) => {
    const { t } = useTranslation();

    const babySittingSkinType = {
        1: baby_sitting_skinType_1,
        2: baby_sitting_skinType_2,
        3: baby_sitting_skinType_3,
        4: baby_sitting_skinType_4,
        5: baby_sitting_skinType_5,
        6: baby_sitting_skinType_6,
    };

    return (
        <StyledWrapper>
            {activeDashboard === HealthReportDashboardTypeEnum.LAST_24H &&
                <div className="no-recording-message-block">
                    <div className="info-message">{t('healthReport.noRecording.lastNight') ?? 'The last available night view is not available as it is older than 30 days.'}</div>
                    <img src={babySittingSkinType[patient.skinType]} alt="Baby sitting" width="150"/>
                </div>
            }
            {activeDashboard === HealthReportDashboardTypeEnum.LAST_7DAYS &&
                <div className="no-recording-message-block">
                    <div className="info-message">{t('healthReport.noRecording.7nights') ?? 'No recording for the last 7 nights.'}</div>
                    <img src={babySittingSkinType[patient.skinType]} alt="Baby sitting" width="150"/>
                </div>
            }
            {activeDashboard === HealthReportDashboardTypeEnum.LAST_30DAYS &&
                <div className="no-recording-message-block">
                    <div className="info-message">{t('healthReport.noRecording.30nights') ?? 'No recording for the last 30 nights.'}</div>
                    <img src={babySittingSkinType[patient.skinType]} alt="Baby sitting" width="150"/>
                </div>
            }
            {activeDashboard === HealthReportDashboardTypeEnum.TRENDS &&
                <div className="no-recording-message-block">
                    <div className="info-message">{t('healthReport.noRecording.90nights') ?? 'No recording for the last 90 nights.'}</div>
                    <img src={babySittingSkinType[patient.skinType]} alt="Baby sitting" width="150"/>
                </div>
            }
        </StyledWrapper>
    );
};

HealthReportNoRecording.propTypes = {
    patient: PropTypes.object.isRequired,
    activeDashboard: PropTypes.number.isRequired,
};

//language=SCSS
const StyledWrapper = styled.div`
& {
    .no-recording-message-block {
        margin: 50px auto 0;
        text-align: center;
        
        .info-message {
            display: inline-block;
            margin: 0 auto;
        }
        
        img {
            display: block;
            margin: 20px auto 0;
        }
    }
}
`;

export {HealthReportNoRecording};
